import { render, staticRenderFns } from "./Maskbig.vue?vue&type=template&id=69441e55&scoped=true&"
import script from "./Maskbig.vue?vue&type=script&lang=ts&"
export * from "./Maskbig.vue?vue&type=script&lang=ts&"
import style0 from "./Maskbig.vue?vue&type=style&index=0&id=69441e55&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69441e55",
  null
  
)

export default component.exports